var _ViewColumn;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { string } from 'prop-types';
import { useTheme } from '@mui/material/styles';
import clsx from 'clsx';
import { ViewColumn } from 'mosaic-react-icons';
import SovosIconButton from '../sovos-icon-button/SovosIconButton';
import useMosaicTranslation from '../internals/i18n/useMosaicTranslation';

/**
 * `SovosToolbarColumn` (opens a drawer to configure columns). **Note**:
 * must be a child of `SovosToolbarActions` component
 */
const SovosToolbarColumn = _ref => {
  let {
    className,
    color,
    tooltipText,
    ...props
  } = _ref;
  const {
    palette
  } = useTheme();
  const {
    t
  } = useMosaicTranslation();
  return /*#__PURE__*/React.createElement(SovosIconButton, _extends({}, props, {
    tooltipText: tooltipText || t('toolbarColumn.tooltip'),
    className: clsx('sovosToolbarColumn', className),
    color: color || palette.text.secondary
  }), _ViewColumn || (_ViewColumn = /*#__PURE__*/React.createElement(ViewColumn, null)));
};
SovosToolbarColumn.propTypes = {
  /**
   * Extend the class name applied to the root element
   */
  className: string,
  /**
   * Can be 'primary', 'default', or a valid css Hex color. Default is the
   * text color.
   */
  color: string,
  /**
   * Tooltip for the icon
   */
  tooltipText: string
};
export default SovosToolbarColumn;